import React, { Component, useState, useEffect } from "react";
import { Lealtad } from "./Lealtad";
import { Cel } from "./Cel";
import axios from "axios";
import { Email } from "./Email";
import { ConfirmCode } from "./ConfirmCode";
import { ModalVerify } from "./ModalVerify";
import { ConfirmEmailCode } from "./EmailConfirm";

export const VerifyHome = ({
  user,
  ap,
  passPortal,
  redirect,
  deviceId,
  optionsVerify,
}) => {
  const [verifyMethod, setverifyMethod] = useState(() => {

    return optionsVerify.length > 0 ? optionsVerify[0].value : "Lealtad";
  });
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [valid, setValid] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [message, setMessage] = useState("");
  const [body, setBody] = useState({
    ap_mac: ap ? ap.ap_mac : "",
    device_id: deviceId ? deviceId.replace(/:/g, "") : "",
    verify: verifyMethod,
  });
  let body_reset = {
    ap_mac: ap ? ap.ap_mac : "",
    device_id: deviceId ? deviceId.replace(/:/g, "") : "",
    verify: verifyMethod,
  };

  useEffect(() => {
    getMessageWelcome();
  }, []);

  const renderVerifyComponent = () => {
    switch (verifyMethod) {
      case "lealtad":
        return <Lealtad confirm={confirm} />;
      case "sms":
        return <Cel confirm={sentSMS} />;
      case "email":
        return <Email confirm={sendEmail} />;
    }
  };

  //email, device_id, ap_mac, force_send_code
  const sendEmail = async (value, code) => {
    try {
      let b = await setFields(value, code);
      let res = await axios.post("/email", {
        fields: b,
      });
      console.log(res.data);
      confirm(value, code);
    } catch (error) {
      console.error(error);
    }
  };

  const sentSMS = async (value) => {
    try {
      let b = await setFields(value);
      let res = await axios.get("/sms", {
        params: {
          phoneNumber: b.phoneNumber,
        },
      });
      console.log(res.data);
      setCodeSent(true);
    } catch (err) {
      setCodeSent(false);
    }
  };

  const confirm = async (value, code) => {
    console.log(value);
    setLoading(true);
    setShowModal(true);
    let b = await setFields(value, code);
    try {
      let resp = await axios.post("/userReg", {
        fields: b,
      });
      console.log(resp.data);
      if (resp.data.error) {
        setValid(false);
      } else {
        setValid(true);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setValid(false);
      setShowModal(false);
    }
  };

  const setFields = (value, code) => {
    return new Promise((resolve, reject) => {
      let key = "";
      switch (verifyMethod) {
        case "lealtad":
          setBody({
            ...body_reset,
            lealtad_num: value,
          });
          key = "lealtad_num";
          break;
        case "sms":
          setBody({
            ...body_reset,
            phoneNumber: value,
            code,
          });
          key = "phoneNumber";
          break;
        case "email":
          setBody({
            ...body_reset,
            email: value,
          });
          key = "email";
          break;
        case "email_confirm":
          setBody({
            ...body_reset,
            email: value,
            code,
          });
          key = "email";
          break;
      }
      if (verifyMethod)
        resolve({
          ...body_reset,
          verify: verifyMethod === "email_confirm" ? "email" : verifyMethod,
          [key]: value,
          code: code ? code : "",
        });
    });
  };
  const getMessageWelcome = async () => {
    try {
      let res = await axios.get("/message");
      setMessage(res.data.message);
    } catch (error) {
      console.log("error get message", error)
    }
  }

  return (
    <div
      className="main-content w-100"
      style={{ maxWidth: "780px", overflow: "hidden" }}
    >
      {verifyMethod === "email_confirm" && (
        <ConfirmEmailCode
          email={user.email}
          confirm={sendEmail}
          close={() => {
            setShowModal(false)
            redirect()
          }}
        />
      )}
      <ModalVerify
        show={showModal}
        valid={valid}
        loading={loading}
        closeModal={() => setShowModal(false)}
        passPortal={() => {
          setShowModal(false)
          redirect()
        }}
      />
      {codeSent && verifyMethod === "sms" && (
        <ConfirmCode
          confirm={confirm}
          phoneNumber={body.phoneNumber}
          close={() => setCodeSent(false)}
        />
      )}
      <div className="p-2">
        <div className="row">
          <img
            style={{
              maxWidth: "700px",
              margin: "0 auto",
              width: "80%",
              marginTop: "10px",
              marginBottom: "10px",
            }}
            src="/jpeg/conectate-header.png"
          />
        </div>

        <div className="row justify-content-center">
          <h4 style={{ color: "#203e60" }}>Bienvenido!</h4>
        </div>
        <div className="row p-3">
          <p className="small text-muted">
            {message}
          </p>
        </div>
      </div>
      <div
        className="w-100"
        style={{ paddingLeft: "15px", paddingRight: "15px", margin: "auto" }}
      >
        <div className="form-group">
          <label>Elige una opción de verificación</label>
          <select
            className="form-control"
            value={verifyMethod}
            onChange={(e) => {
              console.log(e.target.value);
              setverifyMethod(e.target.value);
              setBody({
                ...body,
                verify: e.target.value,
              });
              setCodeSent(false);
            }}
          >
            {optionsVerify.map((opt) => {
              return (
                <option key={opt.key} value={opt.value}>
                  {opt.label}
                </option>
              );
            })}
          </select>
        </div>
        <div className="card">{renderVerifyComponent()}</div>
      </div>
    </div>
  );
};
